module.exports = __webpack_public_path__ + "static/media/user-image-3.3de4de25.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/user-image-3.png
// module id = 459
// module chunks = 0